import { useMemo } from "react";
import { useGetScaleQuery, useGetScalesQuery } from "./scaleEndpoints";
import { Scale } from "../../entities/scale";

export function useScale(scaleID: number | undefined) {
  const scaleQuery = useGetScaleQuery(scaleID ?? 0, {
    skip: (scaleID ?? 0) <= 0,
  });
  const scaleEntity = scaleQuery.data;

  return useMemo(() => {
    const ret: typeof scaleQuery & { scale?: Scale | undefined } = {
      ...scaleQuery,
    };
    if (scaleEntity) ret.scale = new Scale(scaleEntity);
    return ret;
  }, [scaleEntity]);
}

export function useScales() {
  const scaleQuery = useGetScalesQuery();
  const scaleEntitiesMap = scaleQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof scaleQuery & {
      scales?: Scale[];
      scalesMap?: { [id: number]: Scale };
    } = {
      ...scaleQuery,
      scales: [],
      scalesMap: {},
    };
    if (scaleEntitiesMap) {
      const scales: Scale[] = [];
      const scalesMap: { [id: number]: Scale } = {};

      for (const key in scaleEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(scaleEntitiesMap, key)) {
          const c = scaleEntitiesMap[key];
          const scale = new Scale(c);
          scales.push(scale);
          scalesMap[scale.id] = scale;
        }
      }
      ret.scales = scales;
      ret.scalesMap = scalesMap;
    }

    return ret;
  }, [scaleEntitiesMap]);
}
